import React from 'react'
import PropTypes from 'prop-types'
import {Box, VStack, Skeleton} from '@chakra-ui/react'

const SkeletonText = ({
    noOfLines = 3,
    spacing = '0.5rem',
    skeletonHeight = '0.5rem',
    isLoaded = false,
    startColor,
    endColor,
    children,
    ...rest
}) => {
    // If content is loaded, show the actual content
    if (isLoaded && children) {
        return <Box {...rest}>{children}</Box>
    }

    // Generate skeleton lines
    return (
        <VStack {...rest} gap={spacing} align="stretch">
            {Array.from({length: noOfLines}, (_, index) => {
                const isLastLine = index === noOfLines - 1
                const lineWidth = isLastLine && noOfLines > 1 ? '80%' : '100%'

                return (
                    <Skeleton
                        key={index}
                        startColor={startColor}
                        endColor={endColor}
                        height={skeletonHeight}
                        width={lineWidth}
                        borderRadius="sm"
                        overflow="hidden"
                    />
                )
            })}
        </VStack>
    )
}

SkeletonText.propTypes = {
    /**
     * The number of skeleton lines to display
     */
    noOfLines: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
    /**
     * The spacing between skeleton lines
     */
    spacing: PropTypes.string,
    /**
     * The height of each skeleton line
     */
    skeletonHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    /**
     * If true, the skeleton will be replaced with the actual content
     */
    isLoaded: PropTypes.bool,
    /**
     * The fade duration in seconds
     */
    fadeDuration: PropTypes.number,
    /**
     * The start color of the skeleton animation
     */
    startColor: PropTypes.string,
    /**
     * The end color of the skeleton animation
     */
    endColor: PropTypes.string,
    /**
     * The actual content to display when loaded
     */
    children: PropTypes.node
}

export default SkeletonText
